import { render } from "./BalTooltip.vue?vue&type=template&id=f4c1fa8e&ts=true"
import script from "./BalTooltip.vue?vue&type=script&lang=ts"
export * from "./BalTooltip.vue?vue&type=script&lang=ts"

import "./BalTooltip.vue?vue&type=style&index=0&id=f4c1fa8e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__